var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxCube2 = function Svg18PxCube2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.63 4.148-4.25-2.465a2.76 2.76 0 0 0-2.76 0L3.37 4.148A2.76 2.76 0 0 0 2 6.526v4.946a2.76 2.76 0 0 0 1.37 2.379l4.25 2.465a2.75 2.75 0 0 0 2.76 0l4.25-2.465A2.76 2.76 0 0 0 16 11.473V6.527a2.76 2.76 0 0 0-1.37-2.379m-1.503 3.326L9.751 9.432v3.927a.75.75 0 0 1-1.5 0V9.432L4.875 7.474a.75.75 0 0 1 .753-1.297l3.374 1.957 3.374-1.957a.75.75 0 0 1 .753 1.297Z"
  })));
};
export default Svg18PxCube2;